import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import NotFound from "@/pages/NotFound";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, lerp: 0.12 });
    window.__lenis = lenis;
    return () => {
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-center" richColors />
    </LanguageProvider>
  );
}

export default App;
